const PIXEL_ID = '1680295553002158'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the canonical Meta Pixel base code (verbatim) into the document head
 * so that Meta Pixel Helper and the Events Manager reliably detect it, then
 * initializes the pixel and fires the first PageView.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  if (document.getElementById('meta-pixel-base')) return
  initialized = true

  // 1. Verbatim Meta Pixel base code as a real <script> tag (best for detection).
  const script = document.createElement('script')
  script.id = 'meta-pixel-base'
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `
  document.head.appendChild(script)

  // 2. <noscript> fallback pixel for users with JavaScript disabled.
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  img.alt = ''
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}

export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', event, params)
}
